/* GENERATED by scripts/gen-data.mjs — chapter "service-split" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_SERVICE_SPLIT: NodeDef = {
  "id": "service-split",
  "tagKey": "path:service-split.tag",
  "x": 40,
  "y": 300,
  "w": 220,
  "h": 116,
  "titleKey": "path:service-split.title",
  "subKey": "path:service-split.sub",
  "blocks": [
    {
      "id": "service-split.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:service-split.b1.title",
      "bodyKey": "path:service-split.b1.body",
      "flowKey": "path:service-split.b1.flow"
    },
    {
      "id": "service-split.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:service-split.b2.title",
      "film": "f-split"
    },
    {
      "id": "service-split.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:service-split.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:service-split.b3o.opts.0.n",
            "wKey": "path:service-split.b3o.opts.0.w",
            "uKey": "path:service-split.b3o.opts.0.u",
            "cKey": "path:service-split.b3o.opts.0.c",
            "slug": "modular-monolith"
          },
          {
            "nKey": "path:service-split.b3o.opts.1.n",
            "wKey": "path:service-split.b3o.opts.1.w",
            "uKey": "path:service-split.b3o.opts.1.u",
            "cKey": "path:service-split.b3o.opts.1.c",
            "slug": "typed-internal-call"
          },
          {
            "nKey": "path:service-split.b3o.opts.2.n",
            "wKey": "path:service-split.b3o.opts.2.w",
            "uKey": "path:service-split.b3o.opts.2.u",
            "cKey": "path:service-split.b3o.opts.2.c",
            "slug": "public-http-json"
          },
          {
            "nKey": "path:service-split.b3o.opts.3.n",
            "wKey": "path:service-split.b3o.opts.3.w",
            "uKey": "path:service-split.b3o.opts.3.u",
            "cKey": "path:service-split.b3o.opts.3.c",
            "slug": "event-consumer"
          },
          {
            "nKey": "path:service-split.b3o.opts.4.n",
            "wKey": "path:service-split.b3o.opts.4.w",
            "uKey": "path:service-split.b3o.opts.4.u",
            "cKey": "path:service-split.b3o.opts.4.c",
            "slug": "gateway-in-front"
          }
        ],
        "ref": "micro"
      }
    },
    {
      "id": "service-split.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:service-split.b3.title",
      "math": {
        "exprKey": "path:service-split.b3.math.expr",
        "readKey": "path:service-split.b3.math.read",
        "useKey": "path:service-split.b3.math.use",
        "ref": "micro"
      }
    },
    {
      "id": "service-split.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:service-split.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:service-split.b4.ex.bins",
        "binCount": 3,
        "items": [
          {
            "tKey": "path:service-split.b4.ex.items.0.t",
            "bin": 1,
            "whyKey": "path:service-split.b4.ex.items.0.why"
          },
          {
            "tKey": "path:service-split.b4.ex.items.1.t",
            "bin": 2,
            "whyKey": "path:service-split.b4.ex.items.1.why"
          },
          {
            "tKey": "path:service-split.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:service-split.b4.ex.items.2.why"
          },
          {
            "tKey": "path:service-split.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:service-split.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
